import React from 'react'
import MuiAvatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import { getInitials } from '@util/string'

interface ProfileAvatarProps {
  avatar: string
  username: string
  size?: 'small' | 'medium' | 'large'
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({
  avatar,
  username,
  size = 'medium',
}) => {
  const sizeConfig = {
    small: { width: 24, height: 24, fontSize: 12 },
    medium: { width: 35, height: 35, fontSize: 16 },
    large: { width: 48, height: 48, fontSize: 20 },
  }

  const currentSize = sizeConfig[size]

  return (
    <Box>
      <MuiAvatar
        sx={({ ues }) => ({
          width: currentSize.width,
          height: currentSize.height,
          fontSize: currentSize.fontSize,
          fontWeight: 700,
          background: avatar && avatar.length > 0 ? 'none' : ues.primary['20'],
          color: ues.primary['120'],
          border: `1px solid ${ues.primary['120']}`,
        })}
        src={
          avatar && avatar.length > 0
            ? `/api/v1/misc/image?image_path=${avatar}`
            : undefined
        }
      >
        {getInitials(username)}
      </MuiAvatar>
    </Box>
  )
}

export default ProfileAvatar
